import { CognitoUser } from "amazon-cognito-identity-js";
import { userPool } from "../aws";
import toastMessage from "../toastMessage";


export const forgotAwsPassword = (username, callback=()=>{}) => {
    var userData = {
        Username: username,
        Pool: userPool,
    };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.forgotPassword({
        onSuccess: () => {
            callback(null, "Password reset code sent successfully");
        },
        onFailure: (err) => {
            callback(err.message, null);
        },
    });
}


// username = email
export const updateAwsPassword = (username, newPassword, otp, callback=()=>{},) => {
    var userData = {
        Username: username,
        Pool: userPool,
    };

    let cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmPassword(otp, newPassword, {
        onSuccess: () => {
            callback(null, 'Password changed successfully');
        },
        onFailure: (err) => {
            callback(err.message, null);
        }
    });
}
